<template>
  <div class="message-container">
    <div class="title">
      <img class="title_img"
           src="../../assets/images/07/xiaoxi_icon.png"
           alt="">
      消息管理
    </div>
    <el-form ref="form"
             :model="form"
             class="message_search"
             :inline="true">
      <el-form-item label="应用名称">
        <el-select v-model="form.appname"
                   size="small">
          <el-option label="V货帮-货主端"
                     value='0'></el-option>
          <el-option label="V货帮-物流端"
                     value="1"></el-option>
          <el-option label="V货帮-司机端"
                     value="2"></el-option>
          <el-option label="V货帮-智能硬件"
                     value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   size="small"
                   class="search_btn"
                   @click="handleSearchClick">查看</el-button>
      </el-form-item>
      <el-form-item class="btn_box">
        <router-link to="message/addMessage">
          <el-button type="warning"
                     size="small"
                     class="add_btn">添加</el-button>
        </router-link>
      </el-form-item>
    </el-form>
    <div class="message_table">
      <el-table :data="data.result"
                style="width: 100%"
                height="100%">
        <el-table-column class-name="number"
                         fixed
                         label=""
                         align="center"
                         type="index"
                         width="1">
        </el-table-column>
        <el-table-column prop="title"
                         header-align="center"
                         align="center"
                         label="标题"
                         min-width="130">
        </el-table-column>
        <el-table-column label="应用名称"
                         header-align="center"
                         align="center"
                         min-width="70">
          <template slot-scope="scope">
            <div v-for="item in scope.row.appname"
                 :label="item"
                 :key="item">{{item}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="createName"
                         label="发布者"
                         header-align="center"
                         align="center"
                         min-width="94">
        </el-table-column>
        <el-table-column label="发布状态"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.status==='0'">已发布</p>
            <p v-else-if="scope.row.status ==='1'">草稿</p>
          </template>
        </el-table-column>
        <el-table-column prop="createTime"
                         label="添加时间"
                         header-align="center"
                         align="center"
                         min-width="94">
        </el-table-column>
        <el-table-column label="操作"
                         class="operation"
                         header-align="center"
                         align="center"
                         width="175">
          <template slot-scope="scope">
            <el-tooltip class="item update"
                        effect="dark"
                        content="修改"
                        placement="top">
              <el-button @click="handleUpdateClick(scope.row.id)"></el-button>
            </el-tooltip>
            <el-tooltip class="item delete"
                        effect="dark"
                        content="删除"
                        placement="top">
              <el-button @click="handleDeleteClick(scope.row.id)"></el-button>
            </el-tooltip>
            <el-tooltip class="item detail"
                        effect="dark"
                        content="详情"
                        placement="top">
              <el-button @click="handleDetailClick(scope.row.id)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="匹配详情"
               :visible.sync="showDetails"
               class="biddingTable"
               trigger="click">
      <div class="msgDetail">
        <div class="detaillist">
          <span>标题：</span>
          <div class="msgdetail">
            {{msgDetail.title}}
          </div>
        </div>
        <div class="detaillist"
             v-if="msgDetail.type === 0">
          <span>消息内容：</span>
          <div class="msgdetail">
            {{msgDetail.content}}
          </div>
        </div>
        <div class="detaillist"
             v-if="msgDetail.type === 1">
          <span>消息内容：</span>
          <div class="msgdetail">
            <div class="imglist">
              <img :src="msgDetail.imgUrl"
                   alt="">
            </div>
          </div>
        </div>
        <div class="detaillist">
          <span>应用名称：</span>
          <div class="msgdetail">
            <div v-for="item in msgDetail.appname"
                 :label="item"
                 :key="item">{{item}}</div>
          </div>
        </div>
        <div class="detaillist">
          <span>状态：</span>
          <div class="msgdetail">
            <div v-if="msgDetail.status === '0'">发布</div>
            <div v-else-if="msgDetail.status === '1'">草稿</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 分页 -->
    <div class="pages">
      <span class="demonstartion"> 共{{data.total}}条记录</span>
      <el-pagination @current-change="handleCurrentChange"
                     :page-size="data.pageSize"
                     layout="prev, pager, next"
                     :total="data.total"
                     background>
      </el-pagination>

    </div>
  </div>
</template>

<script>
import { messageList, deleteMessage } from 'apis/index'
export default {
  name: 'Container',
  data () {
    return {
      form: {
        appname: ''
      },
      data: [],
      appOptions: [{
        value: '0',
        label: 'V货帮-货主端'
      },
      {
        value: '1',
        label: 'V货帮-物流端'
      },
      {
        value: '2',
        label: 'V货帮-司机端'
      }, {
        value: '3',
        label: 'V货帮-智能硬件'
      }],
      showDetails: false,
      msgDetail: [],
      pageNum: 1
    }
  },
  mounted () {
    this.getMessageList()
  },
  methods: {
    getMessageList () { // 初始化获取信息
      messageList({
        pageNum: this.pageNum,
        appName: this.form.appname
      }).then(res => {
        if (res.data.code === 200) {
          this.data = res.data.data
          this.data.result.forEach(element => {
            let names = element.appName.split(',')
            let namelist = []
            names.forEach(namesElement => {
              this.appOptions.forEach(element => {
                if (namesElement === element.value) {
                  namelist.push(element.label)
                }
              })
            })
            element.appname = namelist
          })
        }
      })
    },
    handleCurrentChange (val) { // 分页
      this.pageNum = val
      this.getMessageList()
    },
    // handleAddClick () { // 添加message
    //   this.$store.commit('message/showAddMessage', true)
    //   let messageInfo = {
    //     imgUrl: 'http://img.zcool.cn/community/01528a58e4c8e6a801219c77b0154e.png@900w_1l_2o_100sh.jpg'
    //   }
    //   this.$store.commit('message/updateMessage', messageInfo)
    // },
    handleSearchClick () { // 查询
      this.getMessageList()
    },
    handleUpdateClick (id) { // 修改
      this.$router.push({
        path: 'message/addMessage',
        query: {
          item: id
        }
      })
    },
    handleDeleteClick (id) { // 删除
      deleteMessage({
        id: id
      }).then(res => {
        if (res.data.code === 200) {
          for (var i = 0; i < this.data.result.length; i++) { // 从当前列别表中删除该数据
            if (this.data.result[i].id === id) {
              this.data.result.splice(i, 1)
              this.data.total -= 1
            }
          }
        }
      })
    },
    handleDetailClick (id) { // 查看详情
      this.msgDetail = []
      this.showDetails = true
      messageList({
        id: id
      }).then(res => {
        if (res.data.code === 200) {
          this.msgDetail = res.data.data.result[0]
          let namelist = []
          let names = this.msgDetail.appName.split(',')

          names.forEach(namesElement => {
            this.appOptions.forEach(element => {
              if (namesElement === element.value) {
                namelist.push(element.label)
              }
            })
          })
          this.msgDetail.appname = namelist
        }
      })
    }
  }
}
</script>
<style lang="stylus">
@import '~styles/mixins.styl'
@import '~styles/varibles.styl'
.message-container
  padding 20px
  height 100%
  .title
    width 100%
    height 46px
    line-height 46px
    color #212832
    border-bottom 1px solid #cfd5dc
    background #fff
    .title_img
      margin 0 8px 0 14px
  .message_search
    width calc(100% - 40px)
    padding 0 20px
    position relative
    background #fff
    .el-form-item
      margin-bottom 5px
    .search_btn
      searchBtn()
      margin-left 22px
    .btn_box
      width 80px
      float right
      position absolute
      top 0
      right 0
      .add_btn
        addBtn()
    .el-input
      margin-left 10px
      width 210px
  .message_table
    height calc(100% - 170px)
  .el-table
    background #f7f9fb
    .cell
      size12()
      .el-button
        padding 6px 14px
        width 28px
        cursor pointer
        height 28px
        margin 0 8px
        &.update
          update()
        &.detail
          detail()
        &.delete
          delete()
  .el-table th
    background #e7f0f8
    .cell
      height 25px
      line-height 25px
  .el-dialog
    width auto
    width 600px
    .el-dialog__header
      height 42px
      padding 0 20px 0
      background #1b88ee
      .el-dialog__title
        line-height 42px
        font-size 13px
        color #fff
        float left
      .el-dialog__headerbtn
        top 12px
        right 12px
        .el-dialog__close
          color #fff
          font-size 20px
    .el-dialog__body
      padding 25px 20px
      overflow hidden
      .msgDetail
        .detaillist
          width 100%
          overflow hidden
          span
            text-align right
            width 110px
            float left
            margin-right 20px
            line-height 30px
            color #5E656F
          .msgdetail
            float left
            width 400px
            color #212832
            line-height 30px
            .imglist
              position relative
              width 348px
              height 350px
              // background #ff8888
              img
                width 100%
                position absolute
                top 50%
                left 50%
                transform translate(-50%, -50%)
.el-popover
  max-width 166px
  background #e6f3fe
  border 1px solid #cfd5dc
  border-radius 1px
  size12()
.el-pagination
  color #5e656f
  font-weight 100
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li
  background transparent
  border 1px solid #cfd5dc
.pages
  margin-top 15px
  .demonstartion
    float right
    line-height 45px
    color #5e656f
</style>
